/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Fragment, useState, useContext } from 'react';
import BackendTable from 'react-backend-table';
import ExpenseCreate from '../components/ExpenseCreate';
import ExpensePayment from '../components/ExpensePayment';
import { ToastContainer } from 'react-toastify';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import showLoader from "../helpers/ShowLoader"
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import { AppContext } from '../context/AppContext';
import Select from 'react-select';

export function Expenses() {
    const {currentUser} = useContext(AppContext);
    const [createExpenseModalShow, setCreateExpenseModalShow] = useState(false);
    const [actionChannel, setActionChannel] = useState('');
    const [idAccExpenses, seIdAccExpenses] = useState('');
    const [editExpenseId, setEditExpenseId] = useState('');

    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [selectedProject, setSelectedProject] = useState<{ value: string; label: string; } | null>(null);

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects';

        const response = await fetch(url, getRequestOptions());

        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        setSelectProjectOptions(data.data);
    }

    useEffect(() => {
        getProjectList();
    }, [])


    const handleCreateExpenseModalShow = (actionChannel:string, editId?: string) => {
        setCreateExpenseModalShow(true);
        setActionChannel(actionChannel);
        setEditExpenseId(editId || '');
    }

    const handleCreateExpenseModalClose = () => {
        setCreateExpenseModalShow(false);
        setEditExpenseId('');
        options.reloadMyTable();
    }

    const [paymentExpenseModalShow, setPaymentExpenseModalShow] = useState(false);
    const handlePaymentExpenseModalShow = (data:any) => {
        setPaymentExpenseModalShow(true);
        seIdAccExpenses(data.idAccExpenses);
    }

    const handlePaymentExpenseModalClose = () => {
        setPaymentExpenseModalShow(false);
        options.reloadMyTable();
    }

    // Function to get the label based on status
    const getStatusLabel = (status:string) => {
        switch (status) {
            case 'approved':
                return <span className="badge badge-success label-inline">Approved</span>;
            case 'denied':
                return <span className="badge badge-danger label-inline">Denied</span>;
            case 'requested':
                return <span className="badge badge-warning label-inline">Requested</span>;
            case 'paid':
                return <span className="badge badge-info label-inline">Paid</span>;
            default:
                return null;
        }
    };

    const changeStatus = (rowValue: any) => {

		let oldExpenseAmount = (Number(rowValue.taAmount)===0) && (Number(rowValue.daAmount) === 0) && (Number(rowValue.otherAmount) === 0) ? rowValue.expenseAmount : rowValue.otherAmount;
        Swal.fire({
            title: 'Approve or Deny Expense',
            input: 'select',
            inputAttributes: {
                autocapitalize: 'off',
                placeholder: 'Select Status',
                defaultValue: rowValue.latestStatus,
            },
            inputOptions: {
                approved: 'Approved',
                denied: 'Denied',
            },
            inputValue: rowValue.latestStatus,
            html:
            '<div id="amount-fields" style="margin: 15px 0; border-radius: 8px; display: block;">' +
            '<div style="margin-bottom: 10px;">' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">TA Amount:</label>' +
            '<input type="number" id="ta-amount" class="swal2-input" value="' + (Number(rowValue.taAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">DA Amount:</label>' +
            '<input type="number" id="da-amount" class="swal2-input" value="' + (Number(rowValue.daAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">Other Amount:</label>' +
            '<input type="number" id="other-amount" class="swal2-input" value="' + (Number(oldExpenseAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">Total Amount:</label>' +
            '<input type="number" id="expense-amount" class="swal2-input" value="' + (Number(rowValue.expenseAmount) || 0) + '" readonly style="margin: 0; border: 2px solid #f8f9fa; border-radius: 6px; background-color: #f8f9fa; color: #6c757d; flex: 1;">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="margin: 15px 0;">' +
            '<div style="display: flex; align-items: flex-start; gap: 10px;">' +
            '<label for="remarks" style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px; margin-top: 8px;">Remarks:</label>' +
            '<textarea id="remarks" class="swal2-textarea" placeholder="Enter your remarks here..." style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; font-family: inherit; resize: vertical; min-height: 80px; flex: 1;"></textarea>' +
            '</div>' +
            '</div>',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            didOpen: () => {
                // Add the calculateTotal function to the global scope
                (window as any).calculateTotal = function() {
                    const taAmount = parseFloat((document.getElementById('ta-amount') as HTMLInputElement)?.value || '0');
                    const daAmount = parseFloat((document.getElementById('da-amount') as HTMLInputElement)?.value || '0');
                    const otherAmount = parseFloat((document.getElementById('other-amount') as HTMLInputElement)?.value || '0');
                    const total = taAmount + daAmount + otherAmount;
                    
                    const totalInput = document.getElementById('expense-amount') as HTMLInputElement;
                    if (totalInput) {
                        totalInput.value = total.toFixed(2);
                    }
                };
                
                // Calculate initial total
                setTimeout(() => {
                    (window as any).calculateTotal();
                }, 100);
            },
            preConfirm: (content: any) => {
                const statusInput = Swal.getInput() as unknown as HTMLSelectElement;
                const remarksElement = document.getElementById('remarks') as HTMLTextAreaElement;
                const taAmountElement = document.getElementById('ta-amount') as HTMLInputElement;
                const daAmountElement = document.getElementById('da-amount') as HTMLInputElement;
				const otherAmountElement = document.getElementById('other-amount') as HTMLInputElement;
                const expenseAmountElement = document.getElementById('expense-amount') as HTMLInputElement;
                
                let status = statusInput?.value || '';
                let remarks = remarksElement?.value || '';
                let taAmount = taAmountElement?.value || 0;
                let daAmount = daAmountElement?.value || 0;
				let otherAmount = otherAmountElement?.value || 0;
                let expenseAmount = expenseAmountElement?.value || 0;
                
                let postData: any = { 
                    idAccExpenses: rowValue.idAccExpenses, 
                    status: status, 
                    remarks: remarks,
                    taAmount: parseFloat(taAmount),
                    daAmount: parseFloat(daAmount),
					otherAmount: parseFloat(otherAmount),
                    amount: parseFloat(expenseAmount)
                };
                
                console.log(postData, status, remarks, taAmount, daAmount, expenseAmount);
                updateStatus(postData);
            },
            allowOutsideClick: () => !Swal.isLoading(),
            willClose: () => {
                // Clean up the global function
                delete (window as any).calculateTotal;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                console.log("result.value=", result.value);
            }
        })
    }

    const updateStatus = async (postData: any) => {
        showLoader();
        const requestOptions = postRequestOptions(postData);
        try {
            let response = await fetch(
                `${process.env.REACT_APP_API_URL}expense/update-status`,
                requestOptions
            )
            let respData = await response.json()
            Swal.close();

            if (respData.success === true) {
                toast(<strong>Expense status updated successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                options.reloadMyTable();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: respData.errorMessage,
                })
            }

        } catch (error) {
            Swal.close();
        }
    }

    const handleDeleteExpense = (rowValue: any) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteExpense(rowValue.idAccExpenses);
            }
        });
    }

    const deleteExpense = async (idAccExpenses: string) => {
        showLoader();
        try {
            let response = await fetch(
                `${process.env.REACT_APP_API_URL}expense/delete/${idAccExpenses}`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt(),
                    }
                }
            )
            let respData = await response.json()
            Swal.close();

            if (respData.success === true) {
                toast(<strong>Expense deleted successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                options.reloadMyTable();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Delete Failed',
                    html: respData.errorMessage,
                })
            }

        } catch (error) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Error',
                html: 'An error occurred while deleting the expense.',
            })
        }
    }
    
    let columns = [
        { title: 'ID', field: 'idAccExpenses', sortable: true, searchable: true, thStyle: { textAlign: "center", width: "5%" }, tdStyle: { textAlign: "center" } },
        { title: 'Expense Date', field: 'expenseDate', sortable: true, searchable: true },
        { title: 'Expense Category', field: 'expenseCategory', sortable: true, searchable: true },
        {
            title: 'Requester',
            field: 'userName',
            sortable: true,
            searchable: true,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
                return (
                    <>
                        {(rowValue.userName) ?? ''}
                    </>
                )
            })
        },
        {
            title: 'Approver',
            field: 'approverName',
            sortable: true,
            searchable: true,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
                return (
                    <>
                        {(rowValue.approverName) ?? ''}
                    </>
                )
            })
        },
        {
            title: 'Project',
            field: 'projectName',
            sortable: true,
            searchable: true,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
                return (
                    <>
                        {rowValue.projectName ?? ''}
                    </>
                )
            })
        },
        { 
            title: 'Expense Amount', 
            field: 'expenseAmount', 
            sortable: true, 
            searchable: true, 
            tdStyle: { textAlign: "left" } ,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
                return (
                    <>
                        {rowValue.taAmount && <span className='text-muted'>TA Amount: {rowValue.taAmount}</span>}<br/>
                        {rowValue.daAmount && <span className='text-muted'>DA Amount: {rowValue.daAmount}</span>}<br/>
                        {rowValue.otherAmount && <span className='text-muted'>Other Amount: {rowValue.otherAmount}</span>}<br/>
                        {rowValue.expenseAmount && <span className='text-info'>Total Amount: {rowValue.expenseAmount}</span>}<br/>
                    </>
                )
            })
        },
        {
            title: 'Remarks',
            field: 'remarks',
            sortable: true,
            searchable: true
        },
        {
            title: 'Status',
            field: 'latestStatus',
            sortable: true,
            searchable: true,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
            
                return (
                    <>
                        {getStatusLabel(rowValue.latestStatus)}
                    </>
                );
            }),
        },
        {
            title: 'Status Remarks',
            field: 'latestStatusRemark',
            sortable: true,
            searchable: true
        },
        {
            title: 'File',
            field: 'file',
            sortable: false,
            searchable: false,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
                return (
                    <>
                        {rowValue.file && <a href={process.env.REACT_APP_AWS_URL + "next-crm/uploads/expenses/" + rowValue.idAccExpenses + "/" + rowValue.file} target='_blank' rel='noopener noreferrer'>View File</a>}
                    </>
                )
            })
        },
        {
            title: 'Action',
            field: 'idAccExpenses',
            sortable: false,
            searchable: false,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
            
                return (
                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                        {rowValue.latestStatus === 'requested' && (
                            <button 
                                className="btn btn-warning btn-sm rounded-pill shadow-sm" 
                                title="Edit Expense" 
                                onClick={() => handleCreateExpenseModalShow('requested', rowValue.idAccExpenses)}
                                style={{ minWidth: '80px', fontSize: '12px', fontWeight: '500' }}
                            >
                                <i className="fa fa-edit me-1"></i>
                                Edit
                            </button>
                        )}
                        
                        {(currentUser?.id_roles === 3 || currentUser?.id_roles === 4 || currentUser?.id_roles === 8) && rowValue.latestStatus==='requested' && (
                            <button 
                                className="btn btn-success btn-sm rounded-pill shadow-sm" 
                                title="Update Expense Status and Add Remarks" 
                                onClick={() => changeStatus(rowValue)}
                                style={{ minWidth: '110px', fontSize: '12px', fontWeight: '500' }}
                            >
                                <i className="fa fa-check me-1"></i>
                                Approve/Deny
                            </button>
                        )}
                        
                        {currentUser?.id_roles !== 1 && rowValue.latestStatus==='approved' && (
                            <button 
                                className="btn btn-primary btn-sm rounded-pill shadow-sm" 
                                title="Expense Payment" 
                                onClick={() => handlePaymentExpenseModalShow(rowValue)}
                                style={{ minWidth: '100px', fontSize: '12px', fontWeight: '500' }}
                            >
                                <i className="fa fa-calculator me-1"></i>
                                Payment
                            </button>
                        )}
                        
                        {rowValue.latestStatus === 'requested' && (
                            <button 
                                className="btn btn-danger btn-sm rounded-pill shadow-sm" 
                                title="Delete Expense" 
                                onClick={() => handleDeleteExpense(rowValue)}
                                style={{ minWidth: '80px', fontSize: '12px', fontWeight: '500' }}
                            >
                                <i className="fa fa-trash me-1"></i>
                                Delete
                            </button>
                        )}
                    </div>
                );
            }),
            thStyle: { textAlign: "center", width: "10%" }, tdStyle: { textAlign: "center" }
        },
    ]

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return (myToken != null) ? JSON.parse(myToken) : null;
    }

    let options = {
        title: '',
        url: process.env.REACT_APP_API_URL + 'expenses',
        authorization: 'Bearer ' + jwt(),
        perPage: [10, 20, 50, 100, 500],
        orderBy: 'idAccExpenses',
        orderType: 'desc',
        columnSearch: true,
        reloadMyTable: () => { },
        extraData: { idProjects: selectedProject?.value }
    }

    useEffect(() => {
        options.reloadMyTable();
    }, [selectedProject])

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className='card-title'>
                        <h3 className='card-label'>Expenses</h3>
                        <small className='text-muted'>| A List of All Expenses</small>
                    </div>
                    <div className="card-toolbar">
                        <div className='d-flex justify-content-end'>
                            <Select
                                defaultValue={selectProjectOptions}
                                onChange={setSelectedProject}
                                options={selectProjectOptions}
                                placeholder="Select project"
                            />
                             &nbsp;
                            {currentUser?.id_roles === 1 &&
                                <button type="button" className="btn btn-sm btn-primary me-2" onClick={() => handleCreateExpenseModalShow('requested')}><i className="fa fa-plus"></i>Make Request</button>
                            }
                            {currentUser?.id_roles !== 1 &&
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateExpenseModalShow('paid')}><i className="fa fa-plus"></i>Add Expense</button>
                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="data-table col-md-12">
                            <BackendTable columns={columns} options={options} />
                        </div>
                    </div>
                </div>
            </div>

            
            <ExpenseCreate show={createExpenseModalShow} handleClose={handleCreateExpenseModalClose} id={Date.now()} actionChannel={actionChannel} editId={editExpenseId} />
            <ExpensePayment show={paymentExpenseModalShow} handleClose={handlePaymentExpenseModalClose} id={idAccExpenses}/>
            <ToastContainer />
        </>

    )
}

export default Expenses
